import React, { useCallback, useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Avatar from "../../assets/Images/user-avatar.jpg";
import { Col, Form, Row } from "react-bootstrap";
import ButtonCom from "../../components/button/button";
import { ToastContainer, toast } from "react-toastify";
import {
  months,
  getFormattedAttendance,
  getFormattedAttendanceCSV,
  downloadCSV,
  getCapitalizeWord,
  splitMonthIntoWeeks,
} from "../../services/commonServices";
import {
  fetchMonthAttData,
  initMonthAttState,
} from "../../redux/slices/monthAttendanceSlice";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { employeeFullAttendanceRecordPath } from "../../services/config";

const EmployeeAttendance = () => {
  const currentMonth = new Date().getMonth();
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;
  const [searchParams] = useSearchParams();
  const staffId = searchParams.get("staffId");
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    navigate(
      location.pathname === "/daily-attendance/employee-attendance"
        ? "/daily-attendance"
        : "/live-attendance"
    );
  };

  const dispatch = useDispatch();
  const monthAttendanceStore = useSelector((state) => state.monthAttendance);

  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);

  const userName = localStorage.getItem("user-name");

  const [present, setPresent] = useState(0);
  const [absent, setAbsent] = useState(0);
  const [halfDay, setHalfDay] = useState(0);
  const [paidLeave, setPaidLeave] = useState(0);
  const [staffImage, setStaffImage] = useState(null);
  const [weekOffCount, setWeekOffCount] = useState(0);
  const [dateArray, setDateArray] = useState([]);

  const [dates, setDates] = useState([]);
  const [weeks, setWeeks] = useState([]);

  const getMonthAttendance = useCallback((date) => {
    if (user) {
      const data = {
        path: employeeFullAttendanceRecordPath,
        data: {
          userId: user.user_id,
          staffId,
          selectedMonthYear: date,
        },
      };
      dispatch(fetchMonthAttData(data));
    }
  }, []);

  useEffect(() => {
    const date = new Date();
    const year_ = date.getFullYear();
    const currentMonth = date.getMonth() + 1;
    const month_ = currentMonth < 10 ? `0${currentMonth}` : currentMonth;

    if (month && year) {
      const selectedMonthYear = `${year}-${month}-01`;
      getMonthAttendance(selectedMonthYear);
    } else {
      setMonth(month_);
      setYear(year_);
      const selectedMonthYear = `${year_}-${month_}-01`;
      getMonthAttendance(selectedMonthYear);
    }
  }, []);

  const handleMonth = (event) => {
    const { value } = event.target;
    const month = value < 10 ? `0${value}` : value;
    setMonth(month);
    if (year) {
      const selectedMonthYear = `${year}-${month}-01`;
      getMonthAttendance(selectedMonthYear);
    }
  };

  const handleYear = (event) => {
    const { value } = event.target;
    setYear(value);
    if (month) {
      const selectedMonthYear = `${value}-${month}-01`;
      getMonthAttendance(selectedMonthYear);
    }
  };

  useEffect(() => {
    if (monthAttendanceStore.monthAttGetSuccess) {
      const data = monthAttendanceStore.monthAttGetData.data;
      const status = monthAttendanceStore.monthAttGetData.data.status;
      if (status == undefined) {
        // if (status ==)
        setPresent(data.present);
        setAbsent(data.absent);
        setHalfDay(data.halfDay);
        setPaidLeave(data.paidLeave);
        setStaffImage(data.staffImage);
        setWeekOffCount(data.weekOffCount);

        const attendanceArray = data.employeeAttendance;
        setDateArray(attendanceArray);
        setDates(getFormattedAttendance(attendanceArray));

        const groupedWeeks = splitMonthIntoWeeks(
          getFormattedAttendance(attendanceArray)
        );

        // const groupedWeeks = Array.from({ length: Math.ceil(getFormattedAttendance(attendanceArray).length / 7) }, (_, i) =>
        //   getFormattedAttendance(attendanceArray).slice(i * 7, (i + 1) * 7)
        // );

        setWeeks(groupedWeeks);
      } else {
        setDateArray([]);
        setDates([]);
        setPresent(0);
        setAbsent(0);
        setHalfDay(0);
        setPaidLeave(0);
        setStaffImage(0);
        setWeekOffCount(0);
      }
      dispatch(initMonthAttState());
    }
  }, [monthAttendanceStore.monthAttGetSuccess]);

  const checkContent = (day, type) => {
    const dayOrder = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const maxIndex = dayOrder.indexOf(day) + 1;

    const firstWeek =
      weeks[0]
        ?.filter((d) => dayOrder.indexOf(d.day) < maxIndex)
        .map((d) => d.date) || [];

    const lastWeek =
      weeks[weeks.length - 1]
        ?.filter((d) => dayOrder.indexOf(d.day) < maxIndex)
        .map((d) => d.date) || [];

    return firstWeek.includes(1)
      ? "start"
      : lastWeek.includes(1)
      ? `${
          weeks.length == "6" && type == "jc"
            ? "end"
            : weeks.length == "6" && type == "mt"
            ? "10px"
            : "end"
        }`
      : "center";
  };

  const [isActive, setIsActive] = useState(false);
  const [attendanceDetails, setAttendanceDetails] = useState({});
  const [isDateActive, setIsDateActive] = useState("");

  const toggleActive = (detail) => {
    setIsDateActive(detail.date);
    setIsActive(true);
    setAttendanceDetails(detail);
  };

  const toggleInActive = () => {
    setIsDateActive("");
    setIsActive(false);
    setAttendanceDetails({});
  };

  const toggleInActiveIf = () => {
    if (isActive) {
      setIsDateActive("");
      setIsActive(false);
      setAttendanceDetails({});
    }
  };

  const downloadDataInCSV = () => {
    if (dateArray.length) {
      downloadCSV(
        getFormattedAttendanceCSV(dateArray),
        `${userName}_${months[month - 1]}_${year}_attendance.csv`
      );
    } else {
      toast.error("No data for download the report.");
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
      <div className="body-container" onClick={toggleInActiveIf}>
        <div className="page-top-bar">
          <h1 onClick={goBack} style={{ cursor: "pointer" }}>
            <IoIosArrowRoundBack className="icon" /> Employee Attendance
          </h1>
        </div>

        <div className="page-body" style={{ height: "100vh" }}>
          <div className="body-header">
            <div className="left-header">
              <img src={staffImage ? staffImage : Avatar} alt="user-details" />
              <span>{getCapitalizeWord(userName)}</span>
            </div>
            <div className="right-header">
              <Form>
                <Row>
                  <Col sm="6">
                    <Form.Group>
                      <Form.Select
                        onChange={handleMonth}
                        style={{
                          width: "130px",
                          height: "42px",
                          backgroundColor: "#fff",
                        }}
                        disabled={isActive}
                      >
                        {months.map((month, index) => (
                          <option
                            key={index}
                            value={index + 1}
                            selected={currentMonth == index}
                          >
                            {month}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group>
                      <Form.Select
                        onChange={handleYear}
                        style={{
                          width: "130px",
                          height: "42px",
                          backgroundColor: "#fff",
                        }}
                        disabled={isActive}
                      >
                        {Array.from({ length: 5 }, (_, i) => {
                          const y = new Date().getFullYear() - i;
                          return (
                            <option key={y} value={y}>
                              {y}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>

              <ButtonCom
                type="button"
                class_name="p_btn"
                text="Download Report"
                url_or_onclick={isActive ? null : downloadDataInCSV}
                icon={null}
              />
              <ButtonCom
                type="button"
                class_name="p_btn"
                text="Mark All Absent as Present"
                url_or_onclick={() => {}}
                icon={null}
              />
            </div>
          </div>

          <div
            className="body-subheader mt-4 pb-4"
            style={{ borderBottom: "1px solid lightgray" }}
          >
            {[
              { label: "Present", value: present ? present : 0 },
              { label: "Absent", value: absent ? absent : 0 },
              { label: "Half Day", value: halfDay ? halfDay : 0 },
              { label: "Paid Leave", value: paidLeave ? paidLeave : 0 },
              { label: "Week Off", value: weekOffCount ? weekOffCount : 0 },
            ].map((stat, index) => (
              <div
                key={index}
                className={`flex-column ${stat.label
                  .toLowerCase()
                  .replace(" ", "-")}`}
              >
                <span>{stat.label}</span>
                <span>{stat.value}</span>
              </div>
            ))}
          </div>

          {dates.length > 0 ? (
            <div
              className="body-content mt-4"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                  (day) => (
                    <div key={day} className="day-container">
                      <div
                        className="day-names"
                        style={{ position: "relative", top: "1px" }}
                      >
                        {day}
                      </div>

                      {/* <div
                    className="day-inner-container"
                    style={{
                      justifyContent: checkContent(day, "jc"),
                      marginTop: checkContent(day, "mt"),
                    }}
                  >
                    {dates
                      .filter((d) => d.day === day)
                      .map((d, i) => {
                        return (
                          <div
                            key={i}
                            className={`date mt-1 ${d.isPresent} ${
                              d.isWeekOffOrHoliday == "Week Off"
                                ? "weekOff"
                                : null
                            } ${d.isHoliday} ${
                              isDateActive == d.date ? "active" : null
                            } `}
                            onClick={() => toggleActive(d)}
                          >
                            {d.date}
                          </div>
                        );
                      })}
                  </div> */}
                    </div>
                  )
                )}
              </div>

              <table className="employee-attendance">
                {weeks?.map((row, idx) => {
                  const daysData = row.reduce((acc, item) => {
                    acc[item.day] = item;
                    return acc;
                  }, {});
                  return (
                    <tr key={idx}>
                      <td>
                        {daysData["Sun"] && (
                          <div
                            className={`date mt-1 ${daysData["Sun"].isPresent} 
                              ${daysData["Sun"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Sun"].isHoliday} 
                              ${isDateActive === daysData["Sun"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Sun"])}
                          >
                            {daysData["Sun"].date}
                          </div>
                        )}
                      </td>

                      <td>
                        {daysData["Mon"] && (
                          <div
                            className={`date mt-1 ${daysData["Mon"].isPresent} 
                              ${daysData["Mon"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Mon"].isHoliday} 
                              ${isDateActive === daysData["Mon"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Mon"])}
                          >
                            {daysData["Mon"].date}
                          </div>
                        )}
                      </td>

                      <td>
                        {daysData["Tue"] && (
                          <div
                            className={`date mt-1 ${daysData["Tue"].isPresent} 
                              ${daysData["Tue"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Tue"].isHoliday} 
                              ${isDateActive === daysData["Tue"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Tue"])}
                          >
                            {daysData["Tue"].date}
                          </div>
                        )}
                      </td>

                      <td>
                        {daysData["Wed"] && (
                          <div
                            className={`date mt-1 ${daysData["Wed"].isPresent} 
                              ${daysData["Wed"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Wed"].isHoliday} 
                              ${isDateActive === daysData["Wed"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Wed"])}
                          >
                            {daysData["Wed"].date}
                          </div>
                        )}
                      </td>

                      <td>
                        {daysData["Thu"] && (
                          <div
                            className={`date mt-1 ${daysData["Thu"].isPresent} 
                              ${daysData["Thu"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Thu"].isHoliday} 
                              ${isDateActive === daysData["Thu"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Thu"])}
                          >
                            {daysData["Thu"].date}
                          </div>
                        )}
                      </td>

                      <td>
                        {daysData["Fri"] && (
                          <div
                            className={`date mt-1 ${daysData["Fri"].isPresent} 
                              ${daysData["Fri"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Fri"].isHoliday} 
                              ${isDateActive === daysData["Fri"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Fri"])}
                          >
                            {daysData["Fri"].date}
                          </div>
                        )}
                      </td>

                      <td>
                        {daysData["Sat"] && (
                          <div
                            className={`date mt-1 ${daysData["Sat"].isPresent} 
                              ${daysData["Sat"].isWeekOffOrHoliday === "Week Off" ? "weekOff" : ""} 
                              ${daysData["Sat"].isHoliday} 
                              ${isDateActive === daysData["Sat"].date ? "active" : ""} 
                            `}
                            onClick={() => toggleActive(daysData["Sat"])}
                          >
                            {daysData["Sat"].date}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          ) : (
            <h3
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "50px",
                marginBottom: "50px",
              }}
            >
              No data found with given date
            </h3>
          )}
        </div>
      </div>

      {/* 
      {row.map((inRow, inIdx) => {
                        return (
                          <>
                            <td style={{ backgroundColor: "blue" }}>
                              {inRow.day == "Sun" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                            <td style={{ backgroundColor: "yellow" }}>
                              {inRow.day == "Mon" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                            <td style={{ backgroundColor: "pink" }}>
                              {inRow.day == "Tue" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                            <td style={{ backgroundColor: "green" }}>
                              {inRow.day == "Wed" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                            <td style={{ backgroundColor: "lime" }}>
                              {inRow.day == "Thu" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                            <td style={{ backgroundColor: "gray" }}>
                              {inRow.day == "Fri" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                            <td style={{ backgroundColor: "purple" }}>
                              {inRow.day == "Sat" && inRow.date && (
                                <div className="date">{inRow.date}</div>
                              )}
                            </td>
                          </>
                        );
                      })} */}

      <div className={isActive ? "date-hamberger active" : "date-hamberger"}>
        <div className="date-hamberger-header">
          <RxCross2 className="icon" onClick={toggleInActive} />
          Attendance Information
        </div>
        <div className="date-hamberger-body">
          <div className="image">
            <ImageComponent imageUrl={staffImage} fallbackImage={Avatar} />
            {getCapitalizeWord(userName)}
          </div>

          <ul>
            {attendanceDetails.checkInTime != "-" && (
              <li>
                <h4>Check In Time </h4>
                {attendanceDetails.checkInTime}
              </li>
            )}

            {attendanceDetails.checkOutTime != "-" && (
              <li>
                <h4> Check Out Time </h4>
                {attendanceDetails.checkOutTime}
              </li>
            )}

            <li>
              <h4>Date </h4>
              {attendanceDetails.fullDate}
            </li>
            {attendanceDetails.duration != "-" && (
              <li>
                <h4> Duration </h4>
                {attendanceDetails.duration}
              </li>
            )}
            <li>
              <h4>Is Present </h4>
              {attendanceDetails.isPresent}
            </li>
            {attendanceDetails.isWeekOffOrHoliday != "-" && (
              <li>
                <h4> Is Week Off Or Holiday </h4>
                {attendanceDetails.isWeekOffOrHoliday}
              </li>
            )}
            <li>
              <h4>Reason </h4>
              {attendanceDetails.reason}
            </li>
          </ul>
        </div>

        <div className="date-hamberger-fooer">
          <button type="button" className="accept">
            Accept
          </button>
          <button type="button" className="reject">
            Reject
          </button>
        </div>
      </div>
    </>
  );
};

const ImageComponent = ({ imageUrl, fallbackImage }) => {
  const [isValidImage, setIsValidImage] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setIsValidImage(true);
    img.onerror = () => setIsValidImage(false);
    img.src = imageUrl;
  }, [imageUrl]);

  return (
    <div>
      {isValidImage ? (
        <img src={imageUrl} alt="Main" className="imageUrl" />
      ) : (
        <img src={fallbackImage} alt="Fallback" className="imageUrl" />
      )}
    </div>
  );
};

export default EmployeeAttendance;
